import { AssessmentPage } from '@/features/assessment';
import { AssessmentSelectionPage } from '@/features/assessment-selection';
import { ChatPage } from '@/features/chat';
import { LandingPage } from '@/features/landing/LandingPage';
import { ResultsPage } from '@/features/results';
import { StartPage } from '@/features/start';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/start" element={<StartPage />} />
        <Route path="/assessment" element={<AssessmentPage />} />
        <Route path="/assessment/selection" element={<AssessmentSelectionPage />} />
        <Route path="/assessment/chat" element={<ChatPage />} />
        <Route path="/results" element={<ResultsPage />} />
      </Routes>
    </BrowserRouter>
  );
}
